import React, {useState, useEffect} from "react";
import LocationPrompt from "./Assets/LocationPromptWEbp.webp";

const LocationPromptPopup = ({setShowPopup }) => {
   
  const closePopup = () =>{
      console.log("Close icon clicked");
      setShowPopup(false);
  }

    return (
      <div className="fixed inset-0 z-[999] flex items-center justify-center ">
        <div className="w-[360px] flex flex-col justify-center items-center relative rounded-[23px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg">
          <div className="absolute top-2 right-2">
            <img
              className="absolute right-3 top-[6px] cursor-pointer"
              src={require("./Assets/Cross.svg").default}
              alt=""
              onClick={closePopup}
            />
          </div>

          <img
            src={LocationPrompt}
            alt="popup visual"
            className="mb-2 mt-[-60px] w-[200px]"
          />

          <h2
            className="mb-[10px] text-center text-[16px]"
          >
             Location Access Denied
          </h2>
          <p className="text-center text-[14px] w-[280px]">To improve accuracy and provide relevant results, please enable location permissions in your browser.</p>
          <p className="text-center text-[14px] w-[280px]">Go to browser settings → Site Permissions → Enable Location</p>

          <div className="w-full flex justify-center items-center mt-[20px]">
            <button
                className="w-full h-[40px] rounded-[5px] bg-[#B5AAFF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={closePopup}>
                Done
            </button>
          </div>
        </div>
      </div>
    );
  };

export default LocationPromptPopup;
